const getPermission = () => new Promise((resolve, reject) => {
  const permissionResult = Notification.requestPermission((result) => {
    resolve(result);
  });

  if (permissionResult) {
    permissionResult.then(resolve, reject);
  }
});

export default getPermission;
